import { useQuery } from "@tanstack/react-query";

import { listPublicSilverVersions } from "services";

import { LIST_PUBLIC_SILVER_VERSIONS } from "consts";

export const useSilverVersionsPublic = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: [LIST_PUBLIC_SILVER_VERSIONS],
    queryFn: listPublicSilverVersions,
    enabled,
  });
